export default __webpack_public_path__ + "static/media/back-arrow.856f66bf.svg";